<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Amazon Listing
            </h1>

            <nav-amazon :tab="tab"></nav-amazon>

            <card-box v-show="action == ''">
                <button @click="create()" class="btn btn-sm btn-outline-secondary float-right"><i
                        class="fi fi-plus"></i> Create
                    Listing
                </button>
                <card-title class="mb-3">Listing</card-title>

                <table class="table">
                    <tr>
                        <th>Name</th>
                        <th>Products</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th width="150">Action</th>
                        <th width="100"></th>
                    </tr>
                    <tr v-for="item in listings" :key="item.id">
                        <td>{{item.name}}</td>
                        <td>{{item.num_product}}</td>
                        <td>{{item.created_at}}</td>
                        <td>{{item.updated_at}}</td>
                        <td>
                            <button class="btn btn-sm btn-light mr-2" @click="clone(item.id)"><i class="  dripicons-copy

"></i></button>
                            <button class="btn btn-sm btn-light mr-2" @click="edit(item.id)"><i class=" dripicons-document-edit
"></i></button>
                            <button class="btn btn-sm btn-light" @click="remove(item.id)"><i
                                    class=" dripicons-trash"></i>
                            </button>
                        </td>
                        <td><button @click="amzExport(item.id)" class="btn btn-sm btn-primary">Download</button></td>
                    </tr>
                </table>
            </card-box>

            <amazon-listing v-show="action=='edit'" ref="amzListing" @update="editDone"></amazon-listing>

        </div>
    </div>
</template>


<script>
    import NavAmazon from "../components/NavAmazon";
    import CardBox from "../components/CardBox";
    import CardTitle from "../components/CardTitle";
    import AmazonListing from "../components/AmazonListing";

    export default {
        name: "MarketingAmazon",
        components: {AmazonListing, CardTitle, CardBox, NavAmazon},
        data: function () {
            return {
                tab: 'listing',
                action: '',
                listings: []
            }
        },
        methods: {
            amzExport: function (id) {
                let vm = this
                this.export_status = true

                let post = {
                    id: id
                }
                this.$http.post(this.$config.api + 'marketing/amazon/export', post).then(function (res) {
                    vm.$helper.downloadCsv('amazon_feed.csv', res.data)
                    vm.export_status = false
                });
            },
            create: function () {
                if (this.lock) return
                let vm = this
                vm.lock = true
                this.$http.post(this.$config.api + 'marketing/amazon', {}).then(function (res) {
                    vm.action = 'edit'
                    vm.$refs.amzListing.getListing(res.data.id);

                })
            },

            clone: function (id) {
                let vm = this
                this.$http.post(this.$config.api + 'marketing/amazon/clone', {id: id}).then(function () {
                    vm.fetch()
                })
            },

            edit: function (id) {

                this.action = 'edit'
                this.$refs.amzListing.getListing(id);

            },

            editDone: function () {
                this.fetch()
                this.action = ''
            },

            remove: function (id) {


                let vm = this
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You cant revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete(this.$config.api + 'marketing/amazon/' + id).then(function () {
                            vm.fetch()
                        })
                        this.$swal('Deleted', 'You successfully deleted this listing', 'success')
                    } else {
                        this.$swal('Cancelled', 'Your listing is still intact', 'info')
                    }
                })

            },


            fetch: function () {
                let vm = this

                this.$http.get(this.$config.api + 'marketing/amazon').then(function (res) {
                    vm.listings = res.data
                })

            },
        },
        mounted() {
            this.fetch()
            this.$store.commit('ACTIVE_SIDEBAR', 'marketing')
            this.$store.commit('ACTIVE_SIDEBARSUB', 'marketing_amazon')
        }
    }
</script>

<style scoped>

</style>